export const AIApiPath = 'ai';

export enum AiApiRoute {
  Prompt = 'prompt',
  Esko = 'esko',
}

export enum AiRole {
  System = 'system',
  User = 'user',
  Assistant = 'assistant',
}

export enum AiPromptFunction {
  GetQuestionFromKeyword = 'getQuestion',
  GetCompanyKeywords = 'getCompanyKeywords',
  GetSurveyKeywords = 'getSurveyKeywords',
  GetSurveySuggestions = 'getSurveySuggestions',
  GetSurveyQuestionsFromKeywords = 'getSurveyQuestionsFromKeywords',
  GetWebsiteMetaInfo = 'getWebsiteMetaInfo',
  GetOnboardingSurveyDesign = 'getOnboardingSurveyDesign',
  GetOnboardingSurveyTaskCoordinator = 'getOnboardingSurveyTaskCoordinator',
  GetOnboardingSurveyQuestionData = 'getOnboardingSurveyQuestionData',
}

export enum AiPromptConfig {
  SummarizeCompanyInfo = 'summarizeCompanyInfo',
  GetWebsiteMetaInfo = 'websiteMetaInfo',
  GetQuestionFromKeyword = 'questionFromKeyword',
  GetCompanyKeywords = 'companyKeywords',
  GetSurveyKeywords = 'surveyKeywords',
  GetSurveySuggestions = 'surveySuggestions',
  GetSurveyQuestionsFromKeywords = 'surveyQuestionsFromKeywords',
  OnboardingSurveyDesign = 'onboardingSurveyDesign',
  OnboardingSurveyTaskCoordinator = 'onboardingSurveyTaskCoordinator',
  OnboardingSurveyPlan = 'onboardingSurveyPlan',
  OnboardingSurveyQuestionData = 'onboardingSurveyQuestionData',
  OnboardingSurveyEnhancePrompt = 'onboardingSurveyEnhancePrompt',
  OnboardingSurveyName = 'onboardingSurveyName',
}

export interface AiMessage {
  role: AiRole;
  message: string;
}

export interface AiPromptOptions {
  temperature?: number;
  model?: 3;
  modelKey?: string;
  secondaryModelKey?: string;
  functionName?: AiPromptFunction;
  parameters?: {
    function?: string[];
    system?: string[];
    user?: string[];
  };
  imageGallery?: string;
  size?: string;
  style?: string;
  quality?: string;
  imageUrl?: string;
  mask?: string;
  prompt?: string;
  maxTokens?: number;
}
